import { render } from "./CheckBoxesGroup.vue?vue&type=template&id=568874e8&scoped=true"
import script from "./CheckBoxesGroup.vue?vue&type=script&lang=js"
export * from "./CheckBoxesGroup.vue?vue&type=script&lang=js"

import "./CheckBoxesGroup.vue?vue&type=style&index=0&id=568874e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568874e8"]])

export default __exports__